// extracted by mini-css-extract-plugin
export default {"item":"DocumentsItem_item__4oX7U","name":"DocumentsItem_name__fdXKn","text":"DocumentsItem_text__ZrOte","buttonList":"DocumentsItem_buttonList__L2-9k"};